module.exports = __webpack_public_path__ + "static/progetto_martinetti13-d4f02e81e029fad7b332341c74d12a15.jpg";